

export interface ChangesSupportedFeatures {
    aggressiveCachingChange: boolean;
    topologyChange: boolean;
}
